/*
 * Universal Construct — SKU Variant Auto-Select
 *
 * Captures the search term from 3 sources (dataLayer push, input polling, link click)
 * and saves it to sessionStorage. On product pages, if a recent search term matches a
 * variant SKU, auto-redirects to that variant via ?variant= parameter.
 */
(function () {
  'use strict';

  var SK = 'uc_search_term';
  var TK = 'uc_search_time';
  var MAX_AGE_MS = 30000;

  function saveTerm(val) {
    if (!val || val.length < 3) return;
    try {
      sessionStorage.setItem(SK, val);
      sessionStorage.setItem(TK, Date.now().toString());
    } catch (e) { /* ignore */ }
  }

  function findSearchInput() {
    return document.querySelector('input[name="q"].search__input')
      || document.querySelector('input[name="q"][type="search"]')
      || document.querySelector('.js-search-input');
  }

  // ============================================================
  // CAPTURE — runs on every page
  // ============================================================
  function initCapture() {
    // Method 1: intercept dataLayer.push
    window.dataLayer = window.dataLayer || [];
    var origPush = window.dataLayer.push;
    window.dataLayer.push = function () {
      for (var i = 0; i < arguments.length; i++) {
        var obj = arguments[i];
        if (obj && obj.event === 'search' && obj.search_term) {
          saveTerm(obj.search_term);
        }
        if (obj && obj.ecommerce && obj.search_term) {
          saveTerm(obj.search_term);
        }
      }
      return origPush.apply(this, arguments);
    };

    // Method 2: poll input value while search is open
    var pollInterval = null;
    var lastVal = '';

    function startPolling() {
      if (pollInterval) return;
      pollInterval = setInterval(function () {
        var inp = findSearchInput();
        if (inp) {
          var v = inp.value.trim();
          if (v.length >= 3 && v !== lastVal) {
            lastVal = v;
            saveTerm(v);
          }
        }
      }, 150);
    }

    function stopPolling() {
      if (pollInterval) { clearInterval(pollInterval); pollInterval = null; }
      lastVal = '';
    }

    function watchSearchVisibility() {
      var obs = new MutationObserver(function () {
        var inp = findSearchInput();
        if (inp && inp.offsetParent !== null) startPolling();
        else stopPolling();
      });
      obs.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'aria-hidden']
      });
    }

    if (document.body) {
      watchSearchVisibility();
    } else {
      document.addEventListener('DOMContentLoaded', watchSearchVisibility);
    }

    // Method 3: intercept clicks on product links, read input right before navigation
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!link) return;
      var inp = findSearchInput();
      if (inp && inp.value.trim().length >= 3) {
        saveTerm(inp.value.trim());
      }
    }, true);
  }

  // ============================================================
  // REDIRECT — runs only on product pages without ?variant=
  // ============================================================
  function tryRedirect() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    if (window.location.search.indexOf('variant=') !== -1) return;

    var st, tt;
    try {
      st = sessionStorage.getItem(SK);
      tt = sessionStorage.getItem(TK);
    } catch (e) { return; }
    if (!st) return;

    if (tt && (Date.now() - parseInt(tt, 10)) > MAX_AGE_MS) {
      try {
        sessionStorage.removeItem(SK);
        sessionStorage.removeItem(TK);
      } catch (e) { /* ignore */ }
      return;
    }

    try {
      sessionStorage.removeItem(SK);
      sessionStorage.removeItem(TK);
    } catch (e) { /* ignore */ }

    var term = st.toUpperCase().replace(/[\s\-]/g, '');
    var variants = null;
    if (typeof window.meta !== 'undefined' && window.meta.product && window.meta.product.variants) {
      variants = window.meta.product.variants;
    }
    if (!variants) {
      var pj = document.querySelector('[data-product-json]');
      if (pj) {
        try { variants = JSON.parse(pj.textContent).variants; } catch (e) { /* ignore */ }
      }
    }
    if (!variants || !variants.length) return;

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var s = (variants[i].sku || '').toUpperCase().replace(/[\s\-]/g, '');
      if (s === term) { match = variants[i]; break; }
    }
    if (!match) {
      for (var j = 0; j < variants.length; j++) {
        var s2 = (variants[j].sku || '').toUpperCase().replace(/[\s\-]/g, '');
        if (s2 && (s2.indexOf(term) !== -1 || term.indexOf(s2) !== -1)) {
          match = variants[j];
          break;
        }
      }
    }
    if (match) {
      window.location.replace(window.location.pathname + '?variant=' + match.id);
    }
  }

  initCapture();
  tryRedirect();
})();
